
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexs__NXNcWv_45_45lpyGHWn0WFklUzrvCITMehHvf6PQvcZsMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/index.vue?macro=true";
import { default as logingEx7MLRQTmKCPTE1JG_q1WEbHgON7wzpqYvDxXIE0u0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/login.vue?macro=true";
import { default as _91key_93HR307NEtZm2SFhqG61JERANAZvPpqnbqX_WLBNLRvL0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/s/[key].vue?macro=true";
import { default as mgenvSnjSCbmxH4gTPN7yvrgL_UM2n6d6NVpe5_45GI8vzZXAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/mgen.vue?macro=true";
import { default as indexMCvFfRieS0D_45hAM_45lvjaWsqTQpB_45SEaXAZYOdkzsI6gMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/index.vue?macro=true";
import { default as notesEt0NrtPMrw4iaQjm9qaBMSeRpe_45o4l_EgGbHHruyV_EMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/notes.vue?macro=true";
import { default as indexWAewMPe1Icl8tBtteyFc63MuUUmt_45p1AmQYWgeose_cMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentKhRPsKVCS7uM1QXmD1VQkIINWP0D08CazXNz_45665aCYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteqDy52O96FHdno0zK897Tv4yfcJ1PAF5Yh84hufTP3jQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/plan-du-site.vue?macro=true";
import { default as editZCWHzooRGqNwpZ9Vn10QD0Sn9x1qmKNAskSMljhCDIMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/edit.vue?macro=true";
import { default as places8YowzaLC9UxSCcOYr06xLSsmMfIlHGsNeTyOJRxVrDYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/places.vue?macro=true";
import { default as accessibilite_BxhVV8FX7bH7x3NfCCIoRRV80_45MnfJuC8n91lowAAcMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/accessibilite.vue?macro=true";
import { default as _91id_93uuvU8u9FxbUM1aWz92WQbi7SzdHCVGd9LDnPPv8vrgAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/[id].vue?macro=true";
import { default as notificationsju8NcThB_OpsoOOWkgyCN_ffRHs0IA0G3DK4ziM_45wx4Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/notifications.vue?macro=true";
import { default as indexo5q_45CXyDy2qLQQbfSeGalv75HecT5XxbA32LLg6_45d0AMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/index.vue?macro=true";
import { default as indexOFHD1s84YocDfAJRx7QxvP8VdD6YO4ktF_45qfRMbXzmMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/index.vue?macro=true";
import { default as _91slug_93_45BTog5Rt7_bVEQK6L9zLv1qjLEJ69XkYWM8_45PpgRJhIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/villes/[slug].vue?macro=true";
import { default as indexT_45lTGnaTNS7ewjRimpISURMPlx_XGWq4oiDW_V6hEWYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/index.vue?macro=true";
import { default as generique8dUN4LIeq95V2GXVih6RjVILynRWLvoS4t5Sh5ZUxBgMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93xwDpCZU3DcEIYxWkvybfl1QWE7paWLtcdtWrN_Sr0u0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/reseaux/[slug].vue?macro=true";
import { default as missionsAM6lr9QSbOZnvVqk95GODPT__grglz2tlp0HPt1f69QMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/missions.vue?macro=true";
import { default as indexdXKqr8nblaSNGM3djXVs_45kY63Ij8de5ddFyGxESFgOQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/dashboard/index.vue?macro=true";
import { default as favorisfWqaMEoM4cEYNDrV17jwDJby_45b_45_45BmL_45c3evQvjcfA0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93BcViYZedFES2jcKpRgB6s9sQ1x8e03JVLQViVtZHNvEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/activites/[slug].vue?macro=true";
import { default as logsDkhQGFq70ipRVC0Clj7QbPqe0WBBEc30r7TaEhZIvaoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesT9ZnTY41yC2cLf8Stmf3wXK8MUP6hquoVJDl0HcuEkEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesqcc0_45gnSrIGvnw9ntJUh3fZY5tEiR_45gtypRDHa7P_JIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/mentions-legales.vue?macro=true";
import { default as missionsBH1mwFPkIhabn9venf05vCL_45okP3r6v5xwblZ_458o0EsMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/missions.vue?macro=true";
import { default as settingsNjv_cNJvhTC7Aexamt2f1vaJrVP58PNgFllQJkQ1bjIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/settings.vue?macro=true";
import { default as tournee_45ete2n8xKAp_45TFk4SF7N4g1kkfx_gsy7SZARRiC1S6yJ1_45IMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignagesRweA1Df4ZbYGDii0mcDq1DVJeFHLmL_45evDz8E4FWL88Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/temoignages.vue?macro=true";
import { default as indexwPBPuMrXzdzhrkDWSdi26SS5HDkAwZs33GpDQdWi_RoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/index.vue?macro=true";
import { default as admintdNA0IpSXpzF_45bI1Ej93uYXkqkY5G4Q0LnlbdQwRkAIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/maintenance/admin.vue?macro=true";
import { default as indexooTXYLkokWg9Zifa45bAu3gxw3UF8yi6kNNRVcjPo4AMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/maintenance/index.vue?macro=true";
import { default as indexiU9j9TVzUCxS_450RNqTRzugCyGlgcb_fwApk2HLIRbnEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/territoires/index.vue?macro=true";
import { default as _91hash_93xpc2ZxCnkGFkE1COgY770rS08BmGA4w4N5zqMLQ6AcMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursO6PbvRWYeOLReHTeMtkU6dfdF9NuwLR4yctKIxzt7eQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93xL2U6AM29Etxgv2f5cqodLrnrToX_458Mo6rDBXNuaINQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93_V_B7aZb44qBvmGADzy9Msmj39p7RqNmEa_RWvNjuvAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/departements/[slug].vue?macro=true";
import { default as index625zVza8FMIRoK0wS_45SQ4rN_45gutNm2F1Ow9Cso_45O1Q0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/organisations/index.vue?macro=true";
import { default as preferencessWQqCyj_45DUUmhGeJJqkRd_458AvZ4dx3frdTilow3aS9AMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/preferences.vue?macro=true";
import { default as organisationscAjkpmvQ9X6cNAuKd7i_45iKm6_VdZhgWI5pl0_45KSF0IQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/organisations.vue?macro=true";
import { default as _91token_93iPz9AmBAEXlEY7DkLFHYZM9fsPhiHhKUgHpJ5qXH2NcMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/temoignages/[token].vue?macro=true";
import { default as posts83WuEM5Ql8tu5Kfk2zK4SdBK6uOjr6ptqjnLGZ_457QjoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/posts.vue?macro=true";
import { default as indexH5hSQC7bB_19klKm_SDKdXLxUB22hDlUrx4ht4cBgV8Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/index.vue?macro=true";
import { default as addvYl55hyIum8p5UBN4BCkrYfgzSiXvsBANRRB8q_45fkMcMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93X_4vuuGmlpK5husOKZPdtzRf0TxtSXDA8UHHnTiO44oMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/organisations/[slug].vue?macro=true";
import { default as indexuPoZvjoVv_45ZRq7CM8pD7OC7fW5rZXsJWhm6NMnnC0_45YMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/password-reset/index.vue?macro=true";
import { default as participations_45g_wBEPkrPg_45oaJKBpabCsIA_45JQ0S54YZuZhCz3IKkQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/participations.vue?macro=true";
import { default as emailsUcdzRFCIh0L0aE5_454xrwKFcKwGiMR5V5yfH92hppw4gMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/emails.vue?macro=true";
import { default as indexEzrJItOMuei0i9DmjPIeKeaQPanAMpgqgIrfo7tS1D0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsL77RFt497r6CV_nQfZ_01Nr7yrAEAVIXxENId0a6TbcMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/notifications.vue?macro=true";
import { default as index5yxoPLoYypGZ_YBEyn4N6xpjerUvm1A72XZkSj47fvUMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueiaAVw8NvsNySHOSeHLr_8DcoI_45OMFtiRSBbGRoeghtoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_939ZRqNf3vq3JRaYVesFZ_45saRMoxn8eclFNqllXI7HylwMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/domaines-action/[slug].vue?macro=true";
import { default as indexxfLqClUajHXggwy7hNiqlMbER2lArV9sYJYZhx83eIEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_939T7amwq9w3dJzICfe0UPAPnO58IDPMwpINWNbSfTuLIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemble9OCfR32lzUo5E0CqIb9ZQoO4T3FO8i9Rlf7EAnzW07QMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitations3LNU3L1EOuRpKdC9girnY1OX9IRrNfneeOfNooTlMCIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/other/invitations.vue?macro=true";
import { default as messagesUMmGY1zMuExuU_4577KAmLprHDpremd2fS8Amht_45FMQuMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/messages.vue?macro=true";
import { default as placesW0cxcY2BuF004jwURNpNyPIwx_Qt7PlnvJX9zroMawYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/places.vue?macro=true";
import { default as addF5sRSkhJK2Mbx6l1s9TsEcN9Rwh9KHZTCz5re3xF8ikMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/add.vue?macro=true";
import { default as index2NdVbaaf4wRi_k6xM24rTARFtupbZU3_45EKRKZL9ADykMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexIdnFNrGVD_KA1f8tYxS8RuNuYVM7cMw07Ifi_cc3boQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/missions-benevolat/index.vue?macro=true";
import { default as datesrKfV2OpCmxpf1IPi_455YJkC7ar0185eeKHBFdt_jUxOAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexFMnIHz_45FIOtstMhcpcsD48pYeUka0lPT2LP4wy3Zt_QMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxHwskq5GRodbuqXG2eLeXAruisi0yBGvnITBydj9JgJMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleyAAKaQDuPH1MPaukaqVbyWigOVBAGxpWsSZs6MKWKi4Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexLQrunDHZJA4kjsJJREaGYVy_H0Bd_PcSvNo00oVqENAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/index.vue?macro=true";
import { default as missionsUdTlMUMuvAx1Jo3f2RxAeGcVUE8gCCb_45BpHlu1BnfA8Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/missions.vue?macro=true";
import { default as addGV7cdks01mfcH_45r_74PQMJuVyikauUp7eyTLHQegwBIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuel0jGbRzP3dorSrMZkidVYNS2qm_450_45088RLXW4r0F_agQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexR6U3_45SPHNbsduqsMiLd4D5_2u_45IVbqhJaZaE4dp74HwMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/participations/index.vue?macro=true";
import { default as indexHQLmqrOoH5OZnE64_GKfZr9JKUPvE__45LusN_heUo_bYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/index.vue?macro=true";
import { default as index3adXfbi9zfTvFNT2cHYOgSv_45KDJq7aYSNGjWMo_LAfkMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/index.vue?macro=true";
import { default as addocN4aDhxElQeEJI_45bToD1iPdJiLr0DCGHuLMKrPHtXEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addw7GwiiWcs7EOOSFyyI8hEGGKn5ZnDP8YkPlv1_45IBG0kMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addHHWRmTT7aNmjv9253L_yUQp9LRUX_45t7FA_UZj5ep05QMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexn_1FFIQLnAiELeSG6x5oQPvXkwpUjWLTpqqB9oqbfbgMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsCsguG2Zw78FR3LwK2JPkUcMv3_SRWXllmnlFS0NSbnIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/conversions.vue?macro=true";
import { default as macro_45competencesvkzbyH7NiFe1iP6brvUIdBlyYxt8cGQtmfnahIkX9TUMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/tags/macro-competences.vue?macro=true";
import { default as editVJCXsOlncxUDWUjwf_cYfwYLXL3xfRqcUkhha7lkXtcMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteO6_nrxgwFceqaP5BhKvkGvwFS2loZGqxzjlpbl6NMB4Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexrfdlQdHn_451Ph0RFOX3zR7Lce7Oy8hvL6PEnULGN5HtEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addxBz5cKDBMOuMPmogplXyDXltmx5VmvZ6p_XTMDd5IUoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesgxfIl84DVi3PzF9b2bRbZhMYWfXctQp_V4Iw7svwF6kMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editrjd0Iu63cUzdfCGc6xZsyOCbXQsRgqXo_jm5lseAeIgMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateurskgg6iDX3ltrH1zgwkVxRb8LoSTQmy_452msostwOD5sqIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as index0BEdAcVfN60eihkIfkj1O3rnkdU4bBwC94_45QYqmKnE8Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexpnysWZrcpCYUKfHG0qEbsqVERefBWotdSuj14_jgc5oMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexVanYsQo_M6Fc6L84KNH6pn7ZruiFY7lTMbxvB3gY6YQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/index.vue?macro=true";
import { default as indexuMcoN22BMYa1HIjaySdVgR6GvCsBY1BGbNQVUI8uDGIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendrevQC85NPaffN9UW30wnUrVyAv4G37vnpNZuJT6a2rYcIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexZ_sqrPTY_4TAr_bREzfRuo0M78xDmJseb8unCekUbukMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/index.vue?macro=true";
import { default as add1BQnu3xuD_45AUx3ZQZw8vWbHqBqWMKQwxpGQ3qchvD88Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as index4nVeCobmSaG2EPnrZO_45rFDihI0HQ62J1D5TYG5ik9ksMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editEoAVK3NUL3WjNIRob4w7lJawnuE0u0KWTI7lBuKd5CoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93tAucsWjlUdBfkMlFz3QH5AH1anMNV7oF_45ngZQl19U_45kMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteJzlmZj1UUHREUQAuD8eEMKSGn1jzdKatF50omRA2n_45kMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexqBW_45rXyQS2driQOJW9Jm5xN_9havnTL5lFgG5eX1U3sMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsToxkopvFhq89CHkZGWF_Vuv1lCCnB4GmMHYxLr44rJMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/participations.vue?macro=true";
import { default as indexgNGDN434RkJkks3yFv5YOxjovyupNZVl8fAjazbYfbwMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsikzKqav0bTZ3z2i7BkYFVIesSj4c2_omUpjVDDOCm94Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/referents/activity-logs.vue?macro=true";
import { default as editRZU_uKVl2ACzLUI6015jLbwRZKM5ATfkyReMuSyhOoIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexZ1XVKfl_45Rx_QeADfu8ekPIkOQYjhjR_MF5ERnjhhM70Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsSl4WgTq3ntxX8mxCmfyzcLAskpIYW19J0i0ygnJXytQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablespZuilhagOerHV4bt3i0IxlolL8pxJQ_hzQE20fJA_H0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as edittDJyNLohyTKmO0Yvy9HixlKWEITMbYWjrSePWhsQ6xgMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as index6BNo_izNjtJitza9dogRv9DnUZYRr2I_45Gk_45IuGoGzNEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexU7Eq9U3V1azbfnJtQuNkMhIwE29CIqhwDl9e5GeK0nEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesB1ke50ETWlvmxxDcuEXnDgTAo_IWN_47QzRKrn_sD4wMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as edit_45B9mZXm5pJ4rUD5KZDdBIgK3Vyo2p_45z6CmkTlJQQnLoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profilezVRkNUWIhTFWZtTSQF1ouKlP_45w9P6liFWP3e6IiMNNIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementB87KTxcrN4a_45fRfNThOvazE7PicTK0BZW7_7SGqHE94Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsf18rCNbzFSC5buJUgAqbC0pSgWz6L_7_45w9JSdlgLPS0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/referents/waiting-actions.vue?macro=true";
import { default as edit8N6fyqEudUQgQHIcbi4uWWoZUhSO3rSw9mUHK9o4KsYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addMTabu5tjVKDh6936WFdxVoPmQlwUUf_RJeel8Ujl4iYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationWlnATYmAwi3mJsqB4U_45SlhuK8rWSAnPSlPed9iwNEckMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexnkNHvhdK1ESNxeus_VEpJQRui_457l4L6qaGXm4OlTb90Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editCk8CtJqO20QlUG2SHUSM1paRKS5stKkYAFp9n3r_RSAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsNXuYJnsTgzby0cFLcnixZzoRs7o6ZN8Jda4ijNRrb3UMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationstUrMBRiKYKAh6vj8ZhlGpsb8RwJj0Ul9XKezapODc5IMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesNIgZsvLoWqywXnkftwbsf5sF4oEZoE_C1QDjf0VH898Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexings7cDejhB0fXb3xjwSqTwvL7ronkpjbiiLqa8BxkHcLIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexOf48G1FyGzLWS540vWnXf_4IKwjSZGusJjGy81kXUwUMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editu9_45MMa6F_45pSK9IAJC62p_rnWOBqgKOzwiRi8vQqwoTMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexI8v0gZ1QIkuMhUbOpJZMDMohR48T_BlaW5MzJKDhCjoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileAAQF3nIGC7JRL6DRf_N8sQyfF8ZZceEt_45Cb7qck0zPcMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexYzLK7LhiZJK8SIZMPMg3YbsZD9og8m8_u_45secRHp2JEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editRysCX_VGFquABytv5W223mLqcBKJyYxt4OQDlnY2FIEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addgp8zvOl0sKXGBwhpK_45WRmqyVgtZG9aBgjHwxCD187iYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesfAPxK0CFa5ZABAH0xOa08Wzrm_urKVwa3aBLTw3wllMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferenceshH_28DNOgwfHpHIUferNruRX18E3kMCq_JHb2ySFD7IMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45users8yiqbQje8hCNGhq0DkcYSy4j8tAEAOSF3wJnbwxVaKQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoires4aKnJTZDnbpXBzqggQicHJbTQ7ztAB3UkPBM4ITcekgMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsables8TtUcpowPFKl9IUBVB802IgYV1IGvgUMyAun7offgnQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationzedrtSOB_453oZIQ1wETvwsqD3C0RXYm5iDk93PXaMG8wMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedzNfnHTfEuFreVDitmw5qvfz9aYM2B01BMStDZCH1LwgMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemskWyz1y3MSQE9iE4y6lX0E1uV0Dv6ljKmtbL_N0ZYbUAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45rolebFBHfXDB1WYR2XGdeNvOICmuZs37hzokDT0b71AQlpgMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationssiw9Xch_qweH3FKk9KV3cRMk4ik25Bz6y0funDnQwf0Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as edithmeDLl7fN49h3FgHVvDBUqAQFKGF_cLptHwYg9VUjkEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesXc6NoycLZklQL_8eH1tQxAJFA76sgR__SlSh3M8gwXMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkuNM9p20D4QFimkNjCYQg_PthgjEQMtq_45D0hD3YXefkUMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as index3ynwK7nEXH8_45VDs2j4oI8hmIJJDkOlDW7FnTpccG1wQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectiviteMM5L51WMeg77l3JV7ah5gGT9hop1eKIJncxMfvdBKgEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationDgkoOhkQo7_MTO_A8iMBfVh3XJq0hvuzPdiUwtKn8XwMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsJRdqaIWqCGvAZVR4VZQdAZimeHmXka_45T5qFvcgPEH4AMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrants3p_45Z2LCcyGQSEzU5EJd6bPIt9AnLoAd7ATOOtgiV4AMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantwrTjjfm43GHVjjVv4YD1Xkwmo1pU1jblK_9aMqHHmvIMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexFMy7vZyFGcPX_45J_45dr_45pwQMUFUcVrpaLkaAjFq9Z4JT8Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesOEzsfT_6TjyOkdLRM8hP0gqbwQdrQ4_YqNh7nXdTWAEMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerXnyYFEPOcT7qDgVKB3v2891jPQmmUbEI33wUpdXCVNsMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesc6TLYyPCTTnMitvAbMGuzJI5LRCLtypvbZIGn6pdA8kMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imageszOs9j86lmomBIGiJqcP1Xc3rJgFeoNkuMjh_889VjcQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45details9W3Y8sPzzkobu4nLmg3wYQ8Qu1syEy_45P7KQHmMq3uxoMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedAnUvVQ0Klulg4CQ_RQHgfv4Cnjy4SIxYbYueQ86F0sAMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectYKTkkKQJN9LfkuIZL7zJlcwZMHp8q9votzDXfJtbQRkMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerrWXyIOFv_U9f9z_XIJCWZTiA0RBYbBchD_RYKbn5ADsMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementNOSjjErs57bS8R8kubIpayD5FIN0wuS1q7jH7gsdVUMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationvpDeVAW8K9h0n2qtxkpdkRymiJjrFw_M8KugO5RMZcMMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationWEVOOpG0jyimSuSxcVkPrl_eKSBcWad_45xZTBex7_45stQMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerWXAvjwQRWtTZxn9FuCP0nqTuMoRbPGbIY7_45uV4Q24S8Meta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesTwSVPfw85lOI24sjgdGkKhT0dNyHkc_458kTIxdi5LOaYMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io } from "/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logingEx7MLRQTmKCPTE1JG_q1WEbHgON7wzpqYvDxXIE0u0Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/login.vue")
  },
  {
    name: "s-key",
    path: "/s/:key()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/s/[key].vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenvSnjSCbmxH4gTPN7yvrgL_UM2n6d6NVpe5_45GI8vzZXAMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexMCvFfRieS0D_45hAM_45lvjaWsqTQpB_45SEaXAZYOdkzsI6gMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesEt0NrtPMrw4iaQjm9qaBMSeRpe_45o4l_EgGbHHruyV_EMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexWAewMPe1Icl8tBtteyFc63MuUUmt_45p1AmQYWgeose_cMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editZCWHzooRGqNwpZ9Vn10QD0Sn9x1qmKNAskSMljhCDIMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: places8YowzaLC9UxSCcOYr06xLSsmMfIlHGsNeTyOJRxVrDYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93uuvU8u9FxbUM1aWz92WQbi7SzdHCVGd9LDnPPv8vrgAMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsju8NcThB_OpsoOOWkgyCN_ffRHs0IA0G3DK4ziM_45wx4Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexo5q_45CXyDy2qLQQbfSeGalv75HecT5XxbA32LLg6_45d0AMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexOFHD1s84YocDfAJRx7QxvP8VdD6YO4ktF_45qfRMbXzmMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexT_45lTGnaTNS7ewjRimpISURMPlx_XGWq4oiDW_V6hEWYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generique8dUN4LIeq95V2GXVih6RjVILynRWLvoS4t5Sh5ZUxBgMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93xwDpCZU3DcEIYxWkvybfl1QWE7paWLtcdtWrN_Sr0u0Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsAM6lr9QSbOZnvVqk95GODPT__grglz2tlp0HPt1f69QMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexdXKqr8nblaSNGM3djXVs_45kY63Ij8de5ddFyGxESFgOQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisfWqaMEoM4cEYNDrV17jwDJby_45b_45_45BmL_45c3evQvjcfA0Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsDkhQGFq70ipRVC0Clj7QbPqe0WBBEc30r7TaEhZIvaoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    meta: ressourcesT9ZnTY41yC2cLf8Stmf3wXK8MUP6hquoVJDl0HcuEkEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsBH1mwFPkIhabn9venf05vCL_45okP3r6v5xwblZ_458o0EsMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsNjv_cNJvhTC7Aexamt2f1vaJrVP58PNgFllQJkQ1bjIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45ete2n8xKAp_45TFk4SF7N4g1kkfx_gsy7SZARRiC1S6yJ1_45IMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    meta: temoignagesRweA1Df4ZbYGDii0mcDq1DVJeFHLmL_45evDz8E4FWL88Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexwPBPuMrXzdzhrkDWSdi26SS5HDkAwZs33GpDQdWi_RoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: admintdNA0IpSXpzF_45bI1Ej93uYXkqkY5G4Q0LnlbdQwRkAIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexooTXYLkokWg9Zifa45bAu3gxw3UF8yi6kNNRVcjPo4AMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93xpc2ZxCnkGFkE1COgY770rS08BmGA4w4N5zqMLQ6AcMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursO6PbvRWYeOLReHTeMtkU6dfdF9NuwLR4yctKIxzt7eQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencessWQqCyj_45DUUmhGeJJqkRd_458AvZ4dx3frdTilow3aS9AMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationscAjkpmvQ9X6cNAuKd7i_45iKm6_VdZhgWI5pl0_45KSF0IQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93iPz9AmBAEXlEY7DkLFHYZM9fsPhiHhKUgHpJ5qXH2NcMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: posts83WuEM5Ql8tu5Kfk2zK4SdBK6uOjr6ptqjnLGZ_457QjoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexH5hSQC7bB_19klKm_SDKdXLxUB22hDlUrx4ht4cBgV8Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addvYl55hyIum8p5UBN4BCkrYfgzSiXvsBANRRB8q_45fkMcMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93X_4vuuGmlpK5husOKZPdtzRf0TxtSXDA8UHHnTiO44oMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexuPoZvjoVv_45ZRq7CM8pD7OC7fW5rZXsJWhm6NMnnC0_45YMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participations_45g_wBEPkrPg_45oaJKBpabCsIA_45JQ0S54YZuZhCz3IKkQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsUcdzRFCIh0L0aE5_454xrwKFcKwGiMR5V5yfH92hppw4gMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexEzrJItOMuei0i9DmjPIeKeaQPanAMpgqgIrfo7tS1D0Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsL77RFt497r6CV_nQfZ_01Nr7yrAEAVIXxENId0a6TbcMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: index5yxoPLoYypGZ_YBEyn4N6xpjerUvm1A72XZkSj47fvUMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexxfLqClUajHXggwy7hNiqlMbER2lArV9sYJYZhx83eIEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_939T7amwq9w3dJzICfe0UPAPnO58IDPMwpINWNbSfTuLIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemble9OCfR32lzUo5E0CqIb9ZQoO4T3FO8i9Rlf7EAnzW07QMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitations3LNU3L1EOuRpKdC9girnY1OX9IRrNfneeOfNooTlMCIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesUMmGY1zMuExuU_4577KAmLprHDpremd2fS8Amht_45FMQuMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesW0cxcY2BuF004jwURNpNyPIwx_Qt7PlnvJX9zroMawYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addF5sRSkhJK2Mbx6l1s9TsEcN9Rwh9KHZTCz5re3xF8ikMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: index2NdVbaaf4wRi_k6xM24rTARFtupbZU3_45EKRKZL9ADykMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexIdnFNrGVD_KA1f8tYxS8RuNuYVM7cMw07Ifi_cc3boQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesrKfV2OpCmxpf1IPi_455YJkC7ar0185eeKHBFdt_jUxOAMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexFMnIHz_45FIOtstMhcpcsD48pYeUka0lPT2LP4wy3Zt_QMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxHwskq5GRodbuqXG2eLeXAruisi0yBGvnITBydj9JgJMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleyAAKaQDuPH1MPaukaqVbyWigOVBAGxpWsSZs6MKWKi4Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexLQrunDHZJA4kjsJJREaGYVy_H0Bd_PcSvNo00oVqENAMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsUdTlMUMuvAx1Jo3f2RxAeGcVUE8gCCb_45BpHlu1BnfA8Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addGV7cdks01mfcH_45r_74PQMJuVyikauUp7eyTLHQegwBIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuel0jGbRzP3dorSrMZkidVYNS2qm_450_45088RLXW4r0F_agQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexR6U3_45SPHNbsduqsMiLd4D5_2u_45IVbqhJaZaE4dp74HwMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexHQLmqrOoH5OZnE64_GKfZr9JKUPvE__45LusN_heUo_bYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: index3adXfbi9zfTvFNT2cHYOgSv_45KDJq7aYSNGjWMo_LAfkMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addocN4aDhxElQeEJI_45bToD1iPdJiLr0DCGHuLMKrPHtXEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addw7GwiiWcs7EOOSFyyI8hEGGKn5ZnDP8YkPlv1_45IBG0kMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addHHWRmTT7aNmjv9253L_yUQp9LRUX_45t7FA_UZj5ep05QMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexn_1FFIQLnAiELeSG6x5oQPvXkwpUjWLTpqqB9oqbfbgMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsCsguG2Zw78FR3LwK2JPkUcMv3_SRWXllmnlFS0NSbnIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-tags-macro-competences",
    path: "/admin/tags/macro-competences",
    meta: macro_45competencesvkzbyH7NiFe1iP6brvUIdBlyYxt8cGQtmfnahIkX9TUMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/tags/macro-competences.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editVJCXsOlncxUDWUjwf_cYfwYLXL3xfRqcUkhha7lkXtcMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexrfdlQdHn_451Ph0RFOX3zR7Lce7Oy8hvL6PEnULGN5HtEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addxBz5cKDBMOuMPmogplXyDXltmx5VmvZ6p_XTMDd5IUoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesgxfIl84DVi3PzF9b2bRbZhMYWfXctQp_V4Iw7svwF6kMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editrjd0Iu63cUzdfCGc6xZsyOCbXQsRgqXo_jm5lseAeIgMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateurskgg6iDX3ltrH1zgwkVxRb8LoSTQmy_452msostwOD5sqIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: index0BEdAcVfN60eihkIfkj1O3rnkdU4bBwC94_45QYqmKnE8Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexpnysWZrcpCYUKfHG0qEbsqVERefBWotdSuj14_jgc5oMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrevQC85NPaffN9UW30wnUrVyAv4G37vnpNZuJT6a2rYcIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexZ_sqrPTY_4TAr_bREzfRuo0M78xDmJseb8unCekUbukMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: add1BQnu3xuD_45AUx3ZQZw8vWbHqBqWMKQwxpGQ3qchvD88Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: index4nVeCobmSaG2EPnrZO_45rFDihI0HQ62J1D5TYG5ik9ksMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editEoAVK3NUL3WjNIRob4w7lJawnuE0u0KWTI7lBuKd5CoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteJzlmZj1UUHREUQAuD8eEMKSGn1jzdKatF50omRA2n_45kMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexqBW_45rXyQS2driQOJW9Jm5xN_9havnTL5lFgG5eX1U3sMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsToxkopvFhq89CHkZGWF_Vuv1lCCnB4GmMHYxLr44rJMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsikzKqav0bTZ3z2i7BkYFVIesSj4c2_omUpjVDDOCm94Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editRZU_uKVl2ACzLUI6015jLbwRZKM5ATfkyReMuSyhOoIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexZ1XVKfl_45Rx_QeADfu8ekPIkOQYjhjR_MF5ERnjhhM70Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsSl4WgTq3ntxX8mxCmfyzcLAskpIYW19J0i0ygnJXytQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablespZuilhagOerHV4bt3i0IxlolL8pxJQ_hzQE20fJA_H0Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: edittDJyNLohyTKmO0Yvy9HixlKWEITMbYWjrSePWhsQ6xgMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: index6BNo_izNjtJitza9dogRv9DnUZYRr2I_45Gk_45IuGoGzNEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexU7Eq9U3V1azbfnJtQuNkMhIwE29CIqhwDl9e5GeK0nEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesB1ke50ETWlvmxxDcuEXnDgTAo_IWN_47QzRKrn_sD4wMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: edit_45B9mZXm5pJ4rUD5KZDdBIgK3Vyo2p_45z6CmkTlJQQnLoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profilezVRkNUWIhTFWZtTSQF1ouKlP_45w9P6liFWP3e6IiMNNIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsf18rCNbzFSC5buJUgAqbC0pSgWz6L_7_45w9JSdlgLPS0Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: edit8N6fyqEudUQgQHIcbi4uWWoZUhSO3rSw9mUHK9o4KsYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addMTabu5tjVKDh6936WFdxVoPmQlwUUf_RJeel8Ujl4iYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexnkNHvhdK1ESNxeus_VEpJQRui_457l4L6qaGXm4OlTb90Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editCk8CtJqO20QlUG2SHUSM1paRKS5stKkYAFp9n3r_RSAMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsNXuYJnsTgzby0cFLcnixZzoRs7o6ZN8Jda4ijNRrb3UMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationstUrMBRiKYKAh6vj8ZhlGpsb8RwJj0Ul9XKezapODc5IMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexings7cDejhB0fXb3xjwSqTwvL7ronkpjbiiLqa8BxkHcLIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexOf48G1FyGzLWS540vWnXf_4IKwjSZGusJjGy81kXUwUMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editu9_45MMa6F_45pSK9IAJC62p_rnWOBqgKOzwiRi8vQqwoTMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexI8v0gZ1QIkuMhUbOpJZMDMohR48T_BlaW5MzJKDhCjoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileAAQF3nIGC7JRL6DRf_N8sQyfF8ZZceEt_45Cb7qck0zPcMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexYzLK7LhiZJK8SIZMPMg3YbsZD9og8m8_u_45secRHp2JEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editRysCX_VGFquABytv5W223mLqcBKJyYxt4OQDlnY2FIEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addgp8zvOl0sKXGBwhpK_45WRmqyVgtZG9aBgjHwxCD187iYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesfAPxK0CFa5ZABAH0xOa08Wzrm_urKVwa3aBLTw3wllMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferenceshH_28DNOgwfHpHIUferNruRX18E3kMCq_JHb2ySFD7IMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45users8yiqbQje8hCNGhq0DkcYSy4j8tAEAOSF3wJnbwxVaKQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoires4aKnJTZDnbpXBzqggQicHJbTQ7ztAB3UkPBM4ITcekgMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationzedrtSOB_453oZIQ1wETvwsqD3C0RXYm5iDk93PXaMG8wMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedzNfnHTfEuFreVDitmw5qvfz9aYM2B01BMStDZCH1LwgMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemskWyz1y3MSQE9iE4y6lX0E1uV0Dv6ljKmtbL_N0ZYbUAMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45rolebFBHfXDB1WYR2XGdeNvOICmuZs37hzokDT0b71AQlpgMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationssiw9Xch_qweH3FKk9KV3cRMk4ik25Bz6y0funDnQwf0Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: edithmeDLl7fN49h3FgHVvDBUqAQFKGF_cLptHwYg9VUjkEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesXc6NoycLZklQL_8eH1tQxAJFA76sgR__SlSh3M8gwXMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkuNM9p20D4QFimkNjCYQg_PthgjEQMtq_45D0hD3YXefkUMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: index3ynwK7nEXH8_45VDs2j4oI8hmIJJDkOlDW7FnTpccG1wQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteMM5L51WMeg77l3JV7ah5gGT9hop1eKIJncxMfvdBKgEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationDgkoOhkQo7_MTO_A8iMBfVh3XJq0hvuzPdiUwtKn8XwMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsJRdqaIWqCGvAZVR4VZQdAZimeHmXka_45T5qFvcgPEH4AMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrants3p_45Z2LCcyGQSEzU5EJd6bPIt9AnLoAd7ATOOtgiV4AMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantwrTjjfm43GHVjjVv4YD1Xkwmo1pU1jblK_9aMqHHmvIMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexFMy7vZyFGcPX_45J_45dr_45pwQMUFUcVrpaLkaAjFq9Z4JT8Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesOEzsfT_6TjyOkdLRM8hP0gqbwQdrQ4_YqNh7nXdTWAEMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerXnyYFEPOcT7qDgVKB3v2891jPQmmUbEI33wUpdXCVNsMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesc6TLYyPCTTnMitvAbMGuzJI5LRCLtypvbZIGn6pdA8kMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imageszOs9j86lmomBIGiJqcP1Xc3rJgFeoNkuMjh_889VjcQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45details9W3Y8sPzzkobu4nLmg3wYQ8Qu1syEy_45P7KQHmMq3uxoMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedAnUvVQ0Klulg4CQ_RQHgfv4Cnjy4SIxYbYueQ86F0sAMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerrWXyIOFv_U9f9z_XIJCWZTiA0RBYbBchD_RYKbn5ADsMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationvpDeVAW8K9h0n2qtxkpdkRymiJjrFw_M8KugO5RMZcMMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationWEVOOpG0jyimSuSxcVkPrl_eKSBcWad_45xZTBex7_45stQMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerWXAvjwQRWtTZxn9FuCP0nqTuMoRbPGbIY7_45uV4Q24S8Meta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesTwSVPfw85lOI24sjgdGkKhT0dNyHkc_458kTIxdi5LOaYMeta || {},
    component: () => import("/build/50371b0f-95b4-4d78-88a2-2fab22bfb2fd/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/user/settings",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/statistiques",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  },
  {
    name: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9ioMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubaHaaU3y_nS7VSb7VXdgrFcurzo3WQJZSes_xp_mw9io
  }
]